import { Link } from 'react-router-dom'
import { Home } from 'lucide-react'

export function NotFoundPage() {
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-6 text-center">
      <h1 className="text-3xl font-bold text-foreground mb-2">
        404 — Siden finnes ikke
      </h1>
      <p className="text-muted-foreground mb-8">
        Denne siden ble ikke funnet.
      </p>
      <Link
        to="/"
        className="inline-flex items-center gap-2 px-6 py-3 bg-primary hover:opacity-90 text-primary-foreground font-medium rounded-xl transition-opacity"
      >
        <Home className="w-5 h-5" />
        Hjem
      </Link>
    </div>
  )
}
